import { Pipe, PipeTransform } from '@angular/core';
import { I18N_SERVER_DATE_FORMAT } from '../../../i18n/i18n.config';
import { IMiniChartConfig } from '../dashboard-card-summary/dashboard-card-summary.component';
import * as moment from 'moment';
import { DashboardCardService } from './dashboard-card.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'appDashboardCardStats'
})
export class DashboardCardStatsPipe implements PipeTransform {
  constructor(
    private dashboardCardService: DashboardCardService,
  ) {}

  public transform(statsData: any, smallChartStats: IMiniChartConfig[]): Observable<any[]> {
    return this.dashboardCardService.state$
      .pipe(
        map(({ charts, metrics }) => {
          const firstTwoSelectedCharts: string[] = charts
            .slice(0, 2)
            .map(chartIdx => metrics[chartIdx]);

          const statsForSelectedCharts = firstTwoSelectedCharts
            .map(item => {
              const stats = statsData?.[item];
              return stats?.values?.length
                ? { ...stats, key: item }
                : false;
            })
            .filter(Boolean);

          if (!statsForSelectedCharts.length) {
            return firstTwoSelectedCharts
              .map(item => {
                const config = smallChartStats.find(conf => conf.key === item);
                const itemsNumber = 15;
                return Array(itemsNumber)
                  .fill(0)
                  .reduce(
                    (acc, _, idx) => {
                      acc.data.push(Math.random() * 10);
                      acc.dates.push(
                        moment()
                          .subtract(itemsNumber - idx, 'days')
                          .format(I18N_SERVER_DATE_FORMAT),
                      );
                      return acc;
                    },
                    {
                      name: config?.label,
                      data: [],
                      dates: [],
                    },
                  );
              });
          }

          return statsForSelectedCharts
            .map(stats => {
              const config = smallChartStats.find(conf => conf.key === stats.key);
              return {
                name: config?.label,
                data: stats.values,
                dates: stats.dates,
                isPercentage: config?.isPercentage,
                isCurrency: config?.isCurrency
              };
            });
        }),
      );
  }
}
